<template>
    <div v-if="representatives">
        <v-autocomplete
                v-model="selectedAccountManager"
                label="Account Manager"
                item-text="firstName"
                item-value="id"
                @change="emitSelected"
                :items="representatives"
                return-object
                v-if="!text"
                :error-messages="errorMessages"
                :readonly="readonly"

        />
        <span v-if="text">{{repName}}</span>
    </div>
</template>

<script>
    import REPRESENTATIVES from "../../graphql/RepresentativesAll.gql";

    export default {
        props: {
            value: {
                type: [String],
                default: ""
            },
            text: {
                type: Boolean,
                default: false
            },
            errorMessages: {
                type: Array
            },
            readonly: {
                type: Boolean,
                default:false
            },
        },
        computed: {
            repName() {
                let name = ''
              console.log(this.selectedAccountManager)
                this.representatives.forEach((item) => {
                    if (item.id === this.selectedAccountManager.id || item.id === this.selectedAccountManager) {
                        name = item.firstName + ' ' + item.lastName
                    }
                })
                return name
            }
        },
        data() {
            return {
                selectedAccountManager: this.value === "" || this.value == null ? {id: "7" } : this.value
            }
        },
        apollo: {
            representatives: {
                query: REPRESENTATIVES,
                update: data => data.representatives
            },
        },
        methods: {
            emitSelected(item) {
                this.$emit('input', item.id)
                this.$emit('selected', item)
            }
        },
    }
</script>
